// useChatMixin.js
export const useChatMixin = {
  data() {
    return {
      responseData: null,
      loading: false,
      controllerRef: null,
      api: `${process.env.VUE_APP_APIBASEURL}/portal/ai_common/optimize_content`
    };
  },
  methods: {
    async sendMessage(originalText, aiType, format = '每条内容都是纯文本格式，以<br/>进行段落换行。', onError) {
      if (this.controllerRef) {
        this.controllerRef.abort();
      }
      this.controllerRef = new AbortController();
      this.loading = true;
      this.responseData = { content: '', role: 'system', loading: true };
      try {
        const response = await fetch(this.api, {
          method: 'POST',
          headers: {
            'Connection': 'keep-alive',
            'Content-Type': 'application/json',
            'token':window.localStorage.getItem('token'),
          },
          keepalive: true,
          body: JSON.stringify({ role: '简历优化', originalText, suggestions: `请优化个人简介。${format}`, type: aiType }),
          signal: this.controllerRef.signal,
        });

        if (!response.ok) {
          throw new Error('请求失败');
        }

        const reader = response.body.getReader();
        if (!reader) {
          throw new Error('无法获取响应流');
        }

        let msg = '';
        // 逐块读取响应流
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            console.log('输出完成');
            break;
          }
          const chunkStr = new TextDecoder().decode(value).trim();
          const lines = chunkStr.split('\n');
          for (const line of lines) {
            if (!line.startsWith('data:')) continue;
            const content = line.replace(/^data:/, '').trim();
            // 跳过无用行
            if (
              content === '```' ||
              content.toLowerCase() === 'html' ||
              content === ''
            ) {
              continue;
            }
            try {
              if (content) {
                msg += content;
                this.responseData = { content: msg + '\n', role: 'system', loading: true };
              }
            } catch (err) {
              console.warn("内容解析错误:", content);
            }
          }
        }

      } catch (error) {
        console.error('发送消息失败:', error);
        if (onError) {
          onError('生成失败');
        }
      } finally {
        this.loading = false;
        if (this.responseData) {
          this.responseData = { ...this.responseData, loading: false };
        }
      }
    },

    // 取消当前请求
    abort() {
      if (this.controllerRef) {
        this.controllerRef.abort();
        this.controllerRef = null;
      }
      this.loading = false;
      this.responseData = { content: '', role: 'system', loading: false };
    },

    // 停止请求
    stop() {
      this.loading = false;
      if (this.controllerRef) {
        this.controllerRef.abort();
        this.controllerRef = null;
      }
    }
  },
};
